'use strict';

var _objectWithoutProperties = require("/usr/src/app/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");

var _excluded = ["styles"];
Object.defineProperty(exports, '__esModule', {
  value: true
});

var React = require('react');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefault(React);

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var HamburgerMenu = function HamburgerMenu(_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React__default['default'].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "22"
  }, props), /*#__PURE__*/React__default['default'].createElement("g", {
    "data-name": "Group 842",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: "2"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    "data-name": "Path 866",
    d: "M11 1h12"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    "data-name": "Path 867",
    d: "M1 21h12"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    "data-name": "Path 868",
    d: "M1 11h22"
  })));
};

exports['default'] = HamburgerMenu;